module.exports = __webpack_public_path__ + "img/offersticker.201d8726.svg";